import { z } from 'zod'

export const sendCaptchaCodeByEmailResponseSchema = z.object({
  /** 剩餘分鐘數 */
  minutesRemaining: z.number()
})

export interface SendCaptchaCodeByEmailResponse
  extends z.infer<typeof sendCaptchaCodeByEmailResponseSchema> {}
